module.exports = __webpack_public_path__ + "IES-Institute_of_Education_Sciences-9c3d235388e9b664692bc607c0b79de6.png";